import { connect } from "react-redux";
import Reports from "../components/Reports";
import * as actions from "../actions/reportActions";

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({ ...state.reports });
export default connect(mapStateToProps, actions)(Reports);
